import StudentGuidanceTable from "./StudentGuidanceTable";

export default StudentGuidanceTable;

